<template>
  <div>
    <label class="form-label">{{ label }}</label>
    <input
        type="file"
        ref="fileInput"
        multiple
        accept="image/*"
        class="form-control"
        @change="handleFilesChange"
    />

    <div class="d-flex flex-wrap mt-3 gap-2">
      <div
          v-for="(img, index) in previews"
          :key="index"
          class="position-relative"
          style="width: 120px; height: 120px;"
      >
        <img
            :src="img"
            class="img-thumbnail"
            style="width: 100%; height: 100%; object-fit: cover;"
        />
        <button
            class="btn btn-sm btn-danger position-absolute"
            style="top: 0; right: 0;"
            @click.prevent="removePreview(index)"
        >
          ✕
        </button>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "MultiImageUploader",
    props: {
      label: {
        type: String,
        default: "Uploader des images"
      }
    },
    data() {
      return {
        previews: [],
        files: []
      };
    },
    methods: {
      handleFilesChange(event) {
        const selectedFiles = Array.from(event.target.files);
        selectedFiles.forEach((file) => {
          const reader = new FileReader();
          reader.onload = (e) => {
            this.previews.push(e.target.result);
            this.files.push(file);
            this.$emit("files-changed", this.files);
          };
          reader.readAsDataURL(file);
        });

        // Réinitialiser l'input pour permettre une nouvelle sélection des mêmes fichiers
        this.$refs.fileInput.value = null;
      },
      removePreview(index) {
        this.previews.splice(index, 1);
        this.files.splice(index, 1);
        this.$emit("files-changed", this.files);
      },
      reset() {
        this.previews = [];
        this.files = [];
        this.$refs.fileInput.value = null;
        this.$emit("files-changed", []);
      }
    }
  };
</script>
